import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialClip2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.09 14.475h1.53v10.67h-1.53Zm-1.52 10.67h1.52v1.53h-1.52Zm-1.52 1.53h1.52v1.52h-1.52Zm0-21.34h1.52v16.76h-1.52Zm-1.53 16.76h1.53v1.53h-1.53Zm0-18.28h1.53v1.52h-1.53Zm-4.57 24.38h6.1v1.52h-6.1Zm3.05-4.57h1.52v1.52H16Zm-1.53-1.53H16v1.53h-1.53Zm-1.52-12.19h1.52v12.19h-1.52Zm-1.52-7.62h6.09v1.53h-6.09Zm0 24.39h1.52v1.52h-1.52Zm-1.53-1.53h1.53v1.53H9.9Zm0-21.33h1.53v1.52H9.9Zm-1.52 1.52H9.9v19.81H8.38Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialClip2
